import { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Grid,
  TextField,
  Button,
  Avatar,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  LinearProgress,
  Divider,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Collapse,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import {
  Edit as EditIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  School as SchoolIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Person as PersonIcon,
  Lock as LockIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  Key as KeyIcon,
  MenuBook as CurricularIcon,
  EmojiEvents as ExtracurricularIcon,
  SwapHoriz as TransferIcon,
  TrendingUp as TrendingUpIcon,
  History as HistoryIcon,
  ExpandMore as ExpandMoreIcon,
  CalendarToday as CalendarIcon,
} from '@mui/icons-material';
import { supabase } from '../lib/supabase';
import { useAuth } from '../context/AuthContext';
import { TABLES, RELATIONS, getCurrentSchoolYear } from '../lib/tables';

export default function Profile() {
  const { profile, refreshProfile } = useAuth();
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  
  const [creditsData, setCreditsData] = useState({
    curricular: 0,
    extracurricular: 0,
    transferabil: 0,
    total: 0,
    beneficiiRevendicate: 0,
    crediteCheltuite: 0,
  });
  const [creditsLoading, setCreditsLoading] = useState(true);

  
  const [moduleCredits, setModuleCredits] = useState([]);
  
  
  const [selectedModule, setSelectedModule] = useState(null);
  const [moduleRequests, setModuleRequests] = useState([]);
  const [moduleDialogOpen, setModuleDialogOpen] = useState(false);

  
  const [schoolYearHistory, setSchoolYearHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [showHistory, setShowHistory] = useState(false);

  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [showPasswords, setShowPasswords] = useState({
    current: false,
    new: false,
    confirm: false,
  });
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState('');
  const [userCreatedAt, setUserCreatedAt] = useState(null);

  const [formData, setFormData] = useState({
    nume: '',
    prenume: '',
    telefon: '',
    specializare: '',
    clasa: '',
    clasaManual: '',
  });

  
  useEffect(() => {
    if (profile) {
      setFormData({
        nume: profile.nume || '',
        prenume: profile.prenume || '',
        telefon: profile.telefon || '',
        specializare: profile.specializare || '',
        clasa: profile.clasa || '',
      });
    }
  }, [profile]);

  useEffect(() => {
    let isMounted = true;
    
    const fetchUserCreatedAt = async () => {
      if (profile) {
        const { data: userData } = await supabase.auth.getUser();
        if (isMounted && userData?.user?.created_at) {
          setUserCreatedAt(userData.user.created_at);
        }
      }
    };
    fetchUserCreatedAt();
    
    return () => { isMounted = false; };
  }, [profile]);

  
  useEffect(() => {
    let isMounted = true;
    
    const loadCreditsData = async () => {
      if (!profile || profile.rol !== 'elev') {
        if (isMounted) setCreditsLoading(false);
        return;
      }

      try {
        
        const { data: modulesData, error: modulesError } = await supabase
          .from(TABLES.modules)
          .select('id, cod_module, nume_module, credite_tinta')
          .order('cod_module');

        if (!isMounted) return;

        
        const { data: creditTypes } = await supabase
          .from(TABLES.credit_types)
          .select('id, nume_tip, categorie');

        if (!isMounted) return;

        const creditTypesMap = {};
        creditTypes?.forEach(ct => {
          creditTypesMap[ct.id] = {
            categorie: ct.categorie || ct.nume_tip?.toLowerCase() || ''
          };
        });

        
        const { data: requestsData, error: reqError } = await supabase
          .from(TABLES.credit_requests)
          .select('id_tip_credit, id_module, credite_solicitate, credite_acordate')
          .eq('id_elev', profile.id)
          .eq('status', 'validat');

        if (!isMounted) return;

        
        let curricular = 0;
        let extracurricular = 0;
        let transferabil = 0;

        
        const moduleCreditsMap = {};
        (modulesData || []).forEach(mod => {
          moduleCreditsMap[mod.id] = {
            id: mod.id,
            cod: mod.cod_module,
            nume: mod.nume_module,
            curricular: 0,
            extracurricular: 0,
            transferabil: 0,
            total: 0,
            tinta: mod.credite_tinta || 0
          };
        });

        (requestsData || []).forEach(req => {
          const typeInfo = creditTypesMap[req.id_tip_credit] || {};
          const categorie = typeInfo.categorie || '';
          const credite = req.credite_acordate || req.credite_solicitate || 0;
          
          const idModul = req.id_module;

          
          if (categorie === 'curricular' || (categorie.includes && categorie.includes('curricular') && !categorie.includes('extra'))) {
            curricular += credite;
            if (idModul && moduleCreditsMap[idModul]) {
              moduleCreditsMap[idModul].curricular += credite;
              moduleCreditsMap[idModul].total += credite;
            }
          } else if (categorie === 'extracurricular' || (categorie.includes && categorie.includes('extracurricular'))) {
            extracurricular += credite;
            if (idModul && moduleCreditsMap[idModul]) {
              moduleCreditsMap[idModul].extracurricular += credite;
              moduleCreditsMap[idModul].total += credite;
            }
          } else if (categorie === 'transferabil' || (categorie.includes && categorie.includes('transfer'))) {
            transferabil += credite;
            if (idModul && moduleCreditsMap[idModul]) {
              moduleCreditsMap[idModul].transferabil += credite;
              moduleCreditsMap[idModul].total += credite;
            }
          }
        });

        
        const moduleCreditsArray = Object.values(moduleCreditsMap).sort((a, b) => 
          a.cod.localeCompare(b.cod)
        );

        if (isMounted) {
          setModuleCredits(moduleCreditsArray);
        }

        
        const { data: benefitsData } = await supabase
          .from(TABLES.benefit_usage || 'benefit_usage_v2')
          .select('credite_utilizate')
          .eq('id_elev', profile.id);

        if (!isMounted) return;

        const crediteCheltuite = benefitsData?.reduce((sum, b) => sum + (b.credite_utilizate || 0), 0) || 0;

        setCreditsData({
          curricular,
          extracurricular,
          transferabil,
          total: curricular + extracurricular + transferabil,
          beneficiiRevendicate: benefitsData?.length || 0,
          crediteCheltuite,
        });
      } catch (err) {
        console.error('Error loading credits:', err);
      } finally {
        if (isMounted) setCreditsLoading(false);
      }
    };

    loadCreditsData();
    
    return () => { isMounted = false; };
  }, [profile]);

  
  const handleModuleClick = async (modul) => {
    setSelectedModule(modul);
    setModuleDialogOpen(true);
    
    try {
      
      const { data: requests } = await supabase
        .from(TABLES.credit_requests)
        .select(`
          id, nume_activitate, credite_acordate, data_cerere,
          ${RELATIONS.credit_types}(nume_tip, categorie)
        `)
        .eq('id_elev', profile.id)
        .eq('id_module', modul.id)
        .eq('status', 'validat')
        .order('data_cerere', { ascending: false });
      
      setModuleRequests(requests || []);
    } catch (error) {
      console.error('Error loading module requests:', error);
      setModuleRequests([]);
    }
  };

  
  const loadSchoolYearHistory = async (isMounted = true) => {
    if (!profile || profile.rol !== 'elev') return;
    
    setHistoryLoading(true);
    try {
      
      const { data: historyData, error: historyError } = await supabase
        .from(TABLES.student_class_history)
        .select('*')
        .eq('id_elev', profile.id)
        .order('id', { ascending: false });

      if (historyError) throw historyError;
      if (!isMounted) return;

      
      const historyWithCredits = await Promise.all(
        (historyData || []).map(async (record) => {
          
          const { data: transactions } = await supabase
            .from(TABLES.credit_transactions)
            .select('*')
            .eq('id_elev', profile.id)
            .eq('an_scolar_sursa', record.an_scolar);

          return {
            ...record,
            credite_totale: record.credite_totale_la_schimbare || 0,
            credite_transferate: record.credite_transferate || 0,
            transactions: transactions || []
          };
        })
      );

      if (isMounted) {
        setSchoolYearHistory(historyWithCredits);
      }
    } catch (err) {
      console.error('Error loading school year history:', err);
    } finally {
      if (isMounted) {
        setHistoryLoading(false);
      }
    }
  };

  
  useEffect(() => {
    let isMounted = true;
    
    if (showHistory && schoolYearHistory.length === 0) {
      loadSchoolYearHistory(isMounted);
    }
    
    return () => { isMounted = false; };
  }, [showHistory]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const getSpecializationName = (code) => {
    const specializationsMap = {
      'MI': 'Matematică-Informatică',
      'SN': 'Științe ale Naturii',
      'SS': 'Științe Sociale',
      'FL': 'Filologie',
      'BU': 'Business',
    };
    return specializationsMap[code] || code || 'Nespecificată';
  };

  
  const getMotivLabel = (motiv) => {
    const motiveMap = {
      'promovare': 'Promovare',
      'transfer': 'Transfer',
      'repetent': 'Repetent',
      'corectie': 'Corecție date',
    };
    return motiveMap[motiv] || motiv || 'N/A';
  };

  
  const getMotivColor = (motiv) => {
    switch (motiv) {
      case 'promovare': return 'success';
      case 'transfer': return 'info';
      case 'repetent': return 'warning';
      case 'corectie': return 'default';
      default: return 'default';
    }
  };

  const handleSave = async () => {
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      
      const updates = {
        nume: formData.nume.trim(),
        prenume: formData.prenume.trim(),
        telefon: formData.telefon.trim() || null,
        specializare: formData.specializare || null,
      };

      
      if (profile.rol === 'elev') {
        if (formData.clasa === 'altele') {
          updates.clasa = formData.clasaManual?.trim() || null;
        } else {
          updates.clasa = formData.clasa.trim() || null;
        }
      }

      
      if (!updates.nume || !updates.prenume) {
        throw new Error('Numele și prenumele sunt obligatorii');
      }

      
      const { error: updateError } = await supabase
        .from(TABLES.profiles)
        .update(updates)
        .eq('id', profile.id);

      if (updateError) throw updateError;

      setSuccess('Profil actualizat cu succes!');
      setEditing(false);
      
      
      if (refreshProfile) {
        refreshProfile();
      }
      
    } catch (err) {
      console.error('Error updating profile:', err);
      setError(err.message || 'Eroare la actualizarea profilului');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setEditing(false);
    
    if (profile) {
      setFormData({
        nume: profile.nume || '',
        prenume: profile.prenume || '',
        telefon: profile.telefon || '',
        specializare: profile.specializare || '',
        clasa: profile.clasa || '',
      });
    }
    setError('');
    setSuccess('');
  };

  
  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData({
      ...passwordData,
      [name]: value,
    });
  };

  const togglePasswordVisibility = (field) => {
    setShowPasswords({
      ...showPasswords,
      [field]: !showPasswords[field],
    });
  };

  const validatePassword = () => {
    if (!passwordData.currentPassword) {
      setPasswordError('Introdu parola curentă');
      return false;
    }
    
    if (!passwordData.newPassword) {
      setPasswordError('Introdu noua parolă');
      return false;
    }
    
    if (passwordData.newPassword.length < 6) {
      setPasswordError('Noua parolă trebuie să aibă minim 6 caractere');
      return false;
    }
    
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setPasswordError('Parolele nu se potrivesc');
      return false;
    }
    
    if (passwordData.currentPassword === passwordData.newPassword) {
      setPasswordError('Noua parolă trebuie să fie diferită de cea curentă');
      return false;
    }
    
    return true;
  };

  const handleChangePassword = async () => {
    setPasswordLoading(true);
    setPasswordError('');
    setPasswordSuccess('');

    if (!validatePassword()) {
      setPasswordLoading(false);
      return;
    }

    try {
      
      const { error: signInError } = await supabase.auth.signInWithPassword({
        email: profile.email,
        password: passwordData.currentPassword,
      });

      if (signInError) {
        throw new Error('Parola curentă este incorectă');
      }

      
      const { error: updateError } = await supabase.auth.updateUser({
        password: passwordData.newPassword,
      });

      if (updateError) throw updateError;

      setPasswordSuccess('Parola a fost schimbată cu succes!');
      
      
      setTimeout(() => {
        setChangePasswordOpen(false);
        setPasswordData({
          currentPassword: '',
          newPassword: '',
          confirmPassword: '',
        });
        setPasswordSuccess('');
      }, 2000);
      
    } catch (err) {
      console.error('Error changing password:', err);
      setPasswordError(err.message || 'Eroare la schimbarea parolei');
    } finally {
      setPasswordLoading(false);
    }
  };

  const resetPasswordDialog = () => {
    setChangePasswordOpen(false);
    setPasswordData({
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    });
    setPasswordError('');
    setPasswordSuccess('');
  };

  if (!profile) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  const getRoleDisplay = () => {
    switch (profile.rol) {
      case 'elev': return 'Elev';
      case 'profesor': return 'Profesor';
      case 'coordonator': return 'Coordonator';
      default: return 'Utilizator';
    }
  };

  return (
    <>
      <Container maxWidth="md" sx={{ py: 4, px: { xs: 0, sm: 3 } }}>
        {/* Header */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Profilul meu
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Gestionează informațiile contului tău
          </Typography>
        </Box>

        {/* Mesaje de eroare/succes */}
        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}
        
        {success && (
          <Alert severity="success" sx={{ mb: 3 }}>
            {success}
          </Alert>
        )}

        {/* Card profil */}
        <Card sx={{ mb: 3 }}>
          <CardContent>
            {/* Header card cu butoane */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3, flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 2, sm: 3 } }}>
                <Avatar
                  sx={{
                    width: { xs: 56, sm: 80 },
                    height: { xs: 56, sm: 80 },
                    bgcolor: 'primary.main',
                    fontSize: { xs: 22, sm: 32 },
                  }}
                >
                  {profile.prenume?.[0]}{profile.nume?.[0]}
                </Avatar>
                <Box>
                  <Typography variant="h5" fontWeight="bold">
                    {profile.nume} {profile.prenume}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                    <SchoolIcon fontSize="small" />
                    {getRoleDisplay()}
                    {profile.specializare && ` • ${getSpecializationName(profile.specializare)}`}
                  </Typography>
                  {profile.clasa && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                      Clasa: {profile.clasa}
                    </Typography>
                  )}
                </Box>
              </Box>
              
              {!editing ? (
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', width: { xs: '100%', sm: 'auto' }, flexDirection: { xs: 'column', sm: 'row' } }}>
                  <Button
                    startIcon={<KeyIcon />}
                    variant="outlined"
                    onClick={() => setChangePasswordOpen(true)}
                    sx={{ width: { xs: '100%', sm: 'auto' } }}
                  >
                    Schimbă parola
                  </Button>
                  <Button
                    startIcon={<EditIcon />}
                    variant="contained"
                    onClick={() => setEditing(true)}
                    sx={{ width: { xs: '100%', sm: 'auto' } }}
                  >
                    Editează profil
                  </Button>
                </Box>
              ) : (
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', width: { xs: '100%', sm: 'auto' }, flexDirection: { xs: 'column', sm: 'row' } }}>
                  <Button
                    startIcon={<CancelIcon />}
                    variant="outlined"
                    onClick={handleCancel}
                    disabled={loading}
                    sx={{ width: { xs: '100%', sm: 'auto' } }}
                  >
                    Anulează
                  </Button>
                  <Button
                    startIcon={loading ? <CircularProgress size={20} /> : <SaveIcon />}
                    variant="contained"
                    onClick={handleSave}
                    disabled={loading}
                    sx={{ width: { xs: '100%', sm: 'auto' } }}
                  >
                    {loading ? 'Se salvează...' : 'Salvează'}
                  </Button>
                </Box>
              )}
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Formular */}
            <Grid container spacing={{ xs: 2, sm: 3 }}>
              {/* Nume */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Nume"
                  name="nume"
                  value={formData.nume}
                  onChange={handleInputChange}
                  disabled={!editing}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              {/* Prenume */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Prenume"
                  name="prenume"
                  value={formData.prenume}
                  onChange={handleInputChange}
                  disabled={!editing}
                />
              </Grid>

              {/* Email (doar citire) */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Email"
                  value={profile.email}
                  disabled
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              {/* Telefon */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Telefon"
                  name="telefon"
                  value={formData.telefon}
                  onChange={handleInputChange}
                  disabled={!editing}
                  placeholder="ex: 0722 123 456"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PhoneIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              {/* Specializare - doar afișare pentru elevi, editabil pentru alții */}
              <Grid item xs={12} sm={6}>
                {profile.rol === 'elev' ? (
                  <TextField
                    fullWidth
                    label="Specializare"
                    value={getSpecializationName(formData.specializare) || 'Nespecificată'}
                    disabled
                    helperText="Specializarea poate fi modificată doar de coordonator"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SchoolIcon color="action" />
                        </InputAdornment>
                      ),
                    }}
                  />
                ) : (
                  <FormControl fullWidth>
                    <InputLabel>Specializare</InputLabel>
                    <Select
                      name="specializare"
                      value={formData.specializare}
                      onChange={handleInputChange}
                      label="Specializare"
                      disabled={!editing}
                    >
                      <MenuItem value="MI">Matematică-Informatică (MI)</MenuItem>
                      <MenuItem value="SN">Științe ale Naturii (SN)</MenuItem>
                      <MenuItem value="SS">Științe Sociale (SS)</MenuItem>
                      <MenuItem value="FL">Filologie (FL)</MenuItem>
                      <MenuItem value="BU">Business (BU)</MenuItem>
                    </Select>
                  </FormControl>
                )}
              </Grid>

              {/* Clasa - doar afișare pentru elevi */}
                {profile.rol === 'elev' && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Clasa"
                      value={formData.clasa ? `Clasa ${formData.clasa}` : 'Nespecificată'}
                      disabled
                      helperText="Clasa poate fi modificată doar de coordonator"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SchoolIcon color="action" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
              )}

              {/* Rol (doar afișat) */}
              <Grid item xs={12} sm={profile.rol === 'elev' ? 6 : 12}>
                <TextField
                  fullWidth
                  label="Rol"
                  value={getRoleDisplay()}
                  disabled
                />
              </Grid>
            </Grid>

            {/* Informații suplimentare */}
            <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid #e0e0e0' }}>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                Informații cont
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="body2" color="text.secondary">
                    ID Cont:
                  </Typography>
                  <Typography variant="body2" fontWeight="medium">
                    {profile.id.substring(0, 8)}...
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2" color="text.secondary">
                    Data înregistrării:
                  </Typography>
                  <Typography variant="body2" fontWeight="medium">
                    {userCreatedAt 
                      ? new Date(userCreatedAt).toLocaleDateString('ro-RO') 
                      : 'Necunoscută'
                    }
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Card>

        {/* Secțiune Credite - doar pentru elevi */}
        {profile.rol === 'elev' && (
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <TrendingUpIcon color="primary" />
                Statistici Credite
              </Typography>
              
              {creditsLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  {/* Carduri cu categorii de credite */}
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: { xs: 2, sm: 3 }, width: '100%', mb: 3 }}>
                    <Box sx={{ flex: { xs: '0 0 calc(50% - 8px)', sm: '0 0 calc(33.333% - 16px)' }, display: 'flex' }}>
                      <Card variant="outlined" sx={{ bgcolor: 'primary.50', borderColor: 'primary.main', height: '100%', width: '100%', minHeight: 120, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', p: { xs: 2, sm: 3 } }}>
                        <CardContent sx={{ textAlign: 'center', py: 0, p: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                          <CurricularIcon sx={{ fontSize: { xs: 32, sm: 40 }, color: 'primary.main', mb: 1 }} />
                          <Typography variant="h3" fontWeight="bold" color="primary.main" sx={{ fontSize: { xs: '1.3rem', sm: '1.6rem' } }}>
                            {creditsData.curricular}
                          </Typography>
                          <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                            Credite Curriculare
                          </Typography>
                        </CardContent>
                      </Card>
                    </Box>
                    
                    <Box sx={{ flex: { xs: '0 0 calc(50% - 8px)', sm: '0 0 calc(33.333% - 16px)' }, display: 'flex' }}>
                      <Card variant="outlined" sx={{ bgcolor: 'warning.50', borderColor: 'warning.main', height: '100%', width: '100%', minHeight: 120, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', p: { xs: 2, sm: 3 } }}>
                        <CardContent sx={{ textAlign: 'center', py: 0, p: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                          <ExtracurricularIcon sx={{ fontSize: { xs: 32, sm: 40 }, color: 'warning.main', mb: 1 }} />
                          <Typography variant="h3" fontWeight="bold" color="warning.main" sx={{ fontSize: { xs: '1.3rem', sm: '1.6rem' } }}>
                            {creditsData.extracurricular}
                          </Typography>
                          <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                            Credite Extracurriculare
                          </Typography>
                        </CardContent>
                      </Card>
                    </Box>
                    
                    <Box sx={{ flex: { xs: '0 0 calc(50% - 8px)', sm: '0 0 calc(33.333% - 16px)' }, display: 'flex' }}>
                      <Card variant="outlined" sx={{ bgcolor: 'success.50', borderColor: 'success.main', height: '100%', width: '100%', minHeight: 120, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', p: { xs: 2, sm: 3 } }}>
                        <CardContent sx={{ textAlign: 'center', py: 0, p: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                          <TransferIcon sx={{ fontSize: { xs: 32, sm: 40 }, color: 'success.main', mb: 1 }} />
                          <Typography variant="h3" fontWeight="bold" color="success.main" sx={{ fontSize: { xs: '1.3rem', sm: '1.6rem' } }}>
                            {creditsData.transferabil}
                          </Typography>
                          <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                            Credite Transferabile
                          </Typography>
                        </CardContent>
                      </Card>
                    </Box>
                  </Box>

                  {/* Sumar */}
                  <Divider sx={{ my: 2 }} />
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: { xs: 2, sm: 3 }, width: '100%' }}>
                    <Box sx={{ flex: { xs: '0 0 calc(50% - 8px)', sm: '0 0 calc(25% - 18px)' } }}>
                      <Card sx={{ borderRadius: 3, height: '100%', minHeight: 120, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', p: { xs: 2, sm: 3 } }}>
                        <CardContent sx={{ textAlign: 'center', p: 0 }}>
                          <Typography variant="h3" fontWeight="bold" color="primary" sx={{ fontSize: { xs: '1.3rem', sm: '1.6rem' } }}>
                            {creditsData.total}
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                            Total Credite
                          </Typography>
                        </CardContent>
                      </Card>
                    </Box>
                    <Box sx={{ flex: { xs: '0 0 calc(50% - 8px)', sm: '0 0 calc(25% - 18px)' } }}>
                      <Card sx={{ borderRadius: 3, height: '100%', minHeight: 120, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', p: { xs: 2, sm: 3 } }}>
                        <CardContent sx={{ textAlign: 'center', p: 0 }}>
                          <Typography variant="h3" fontWeight="bold" color="info.main" sx={{ fontSize: { xs: '1.3rem', sm: '1.6rem' } }}>
                            {creditsData.total - creditsData.crediteCheltuite}
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                            Credite Disponibile
                          </Typography>
                        </CardContent>
                      </Card>
                    </Box>
                    <Box sx={{ flex: { xs: '0 0 calc(50% - 8px)', sm: '0 0 calc(25% - 18px)' } }}>
                      <Card sx={{ borderRadius: 3, height: '100%', minHeight: 120, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', p: { xs: 2, sm: 3 } }}>
                        <CardContent sx={{ textAlign: 'center', p: 0 }}>
                          <Typography variant="h3" fontWeight="bold" color="secondary.main" sx={{ fontSize: { xs: '1.3rem', sm: '1.6rem' } }}>
                            {creditsData.beneficiiRevendicate}
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                            Beneficii Revendicate
                          </Typography>
                        </CardContent>
                      </Card>
                    </Box>
                    <Box sx={{ flex: { xs: '0 0 calc(50% - 8px)', sm: '0 0 calc(25% - 18px)' } }}>
                      <Card sx={{ borderRadius: 3, height: '100%', minHeight: 120, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', p: { xs: 2, sm: 3 } }}>
                        <CardContent sx={{ textAlign: 'center', p: 0 }}>
                          <Typography variant="h3" fontWeight="bold" color="error.main" sx={{ fontSize: { xs: '1.3rem', sm: '1.6rem' } }}>
                            {creditsData.crediteCheltuite}
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                            Credite Cheltuite
                          </Typography>
                        </CardContent>
                      </Card>
                    </Box>
                  </Box>
                </>
              )}
            </CardContent>
          </Card>
        )}

        {/* Credite per Modul - doar pentru elevi */}
        {profile.rol === 'elev' && (
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <SchoolIcon color="primary" />
                Credite per Modul
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Detaliere credite pe fiecare modul de studiu
              </Typography>
              
              {creditsLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                  <CircularProgress />
                </Box>
              ) : moduleCredits.length === 0 ? (
                <Alert severity="info">Nu există module configurate.</Alert>
              ) : (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: { xs: 2, sm: 3 }, width: '100%' }}>
                  {moduleCredits.map((modul) => (
                    <Box key={modul.id} sx={{ flex: { xs: '0 0 calc(50% - 8px)', sm: '0 0 calc(50% - 12px)', md: '0 0 calc(33.333% - 16px)' }, display: 'flex' }}>
                      <Card 
                        variant="outlined" 
                        onClick={() => modul.total > 0 && handleModuleClick(modul)}
                        sx={{ 
                          borderRadius: 2,
                          borderColor: modul.total > 0 ? 'primary.main' : 'grey.300',
                          bgcolor: modul.total > 0 ? 'primary.50' : 'grey.50',
                          cursor: modul.total > 0 ? 'pointer' : 'default',
                          transition: 'all 0.2s',
                          width: '100%',
                          height: '100%',
                          minHeight: 120,
                          display: 'flex',
                          flexDirection: 'column',
                          '&:hover': modul.total > 0 ? {
                            transform: 'translateY(-2px)',
                            boxShadow: 3,
                          } : {},
                        }}
                      >
                        <CardContent sx={{ py: 2, flex: 1, display: 'flex', flexDirection: 'column' }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                            <Chip 
                              label={modul.cod} 
                              size="small" 
                              color={modul.total > 0 ? 'primary' : 'default'}
                              sx={{ fontWeight: 'bold' }}
                            />
                            <Typography variant="h5" fontWeight="bold" color={modul.total > 0 ? 'primary.main' : 'text.secondary'}>
                              {modul.total}
                            </Typography>
                          </Box>
                          <Typography variant="body2" fontWeight="medium" noWrap title={modul.nume}>
                            {modul.nume}
                          </Typography>
                          {modul.tinta > 0 && (
                            <Box sx={{ mt: 1.5 }}>
                              <LinearProgress
                                variant="determinate"
                                value={Math.min(100, Math.round((modul.total / modul.tinta) * 100))}
                                color={modul.total >= modul.tinta ? 'success' : 'primary'}
                                sx={{ height: 6, borderRadius: 3 }}
                              />
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                                {modul.total} / {modul.tinta} credite
                              </Typography>
                            </Box>
                          )}
                          <Divider sx={{ my: 1 }} />
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.75rem' }}>
                            <Box sx={{ textAlign: 'center', flex: 1 }}>
                              <Typography variant="caption" display="block" color="primary.main" fontWeight="bold">
                                {modul.curricular}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                Curric.
                              </Typography>
                            </Box>
                            <Divider orientation="vertical" flexItem />
                            <Box sx={{ textAlign: 'center', flex: 1 }}>
                              <Typography variant="caption" display="block" color="warning.main" fontWeight="bold">
                                {modul.extracurricular}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                Extra.
                              </Typography>
                            </Box>
                            <Divider orientation="vertical" flexItem />
                            <Box sx={{ textAlign: 'center', flex: 1 }}>
                              <Typography variant="caption" display="block" color="success.main" fontWeight="bold">
                                {modul.transferabil}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                Transf.
                              </Typography>
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    </Box>
                  ))}
                </Box>
              )}
            </CardContent>
          </Card>
        )}

        {/* Istoricul Anilor Școlari - doar pentru elevi */}
        {profile.rol === 'elev' && (
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Box 
                sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  cursor: 'pointer',
                  '&:hover': { bgcolor: 'action.hover' },
                  borderRadius: 1,
                  p: 1,
                  m: -1
                }}
                onClick={() => setShowHistory(!showHistory)}
              >
                <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <HistoryIcon color="primary" />
                  Istoric Ani Școlari
                </Typography>
                <IconButton size="small">
                  <ExpandMoreIcon 
                    sx={{ 
                      transform: showHistory ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.3s'
                    }} 
                  />
                </IconButton>
              </Box>
              
              <Collapse in={showHistory}>
                <Box sx={{ mt: 2 }}>
                  {historyLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                      <CircularProgress size={30} />
                    </Box>
                  ) : schoolYearHistory.length === 0 ? (
                    <Alert severity="info" sx={{ mt: 2 }}>
                      <Typography variant="body2">
                        Nu există istoric al anilor școlari anteriori. 
                        Istoricul va apărea după prima schimbare de clasă (promovare, transfer, etc.).
                      </Typography>
                    </Alert>
                  ) : (
                    <>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Creditele acumulate în anii școlari anteriori sunt păstrate în istoric.
                      </Typography>
                      
                      <Paper variant="outlined" sx={{ borderRadius: 2, overflowX: 'auto' }}>
                        <Table size="small" sx={{ minWidth: 600 }}>
                          <TableHead>
                            <TableRow sx={{ bgcolor: 'grey.50' }}>
                              <TableCell><strong>An Școlar</strong></TableCell>
                              <TableCell><strong>Clasa</strong></TableCell>
                              <TableCell><strong>Specializare</strong></TableCell>
                              <TableCell align="center"><strong>Credite</strong></TableCell>
                              <TableCell><strong>Motiv Schimbare</strong></TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {schoolYearHistory.map((record, index) => (
                              <TableRow key={record.id || index} hover>
                                <TableCell>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <CalendarIcon fontSize="small" color="action" />
                                    {record.an_scolar}
                                  </Box>
                                </TableCell>
                                <TableCell>
                                  <Chip 
                                    label={record.clasa_veche || 'N/A'} 
                                    size="small" 
                                    variant="outlined"
                                  />
                                </TableCell>
                                <TableCell>
                                  {getSpecializationName(record.specializare_veche)}
                                </TableCell>
                                <TableCell align="center">
                                  <Chip 
                                    label={`${record.credite_totale} credite`}
                                    size="small"
                                    color={record.credite_totale > 0 ? 'success' : 'default'}
                                  />
                                </TableCell>
                                <TableCell>
                                  <Chip 
                                    label={getMotivLabel(record.motiv)}
                                    size="small"
                                    color={getMotivColor(record.motiv)}
                                    variant="outlined"
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Paper>
                      
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>
                        An școlar curent: <strong>{getCurrentSchoolYear()}</strong>
                      </Typography>
                    </>
                  )}
                </Box>
              </Collapse>
            </CardContent>
          </Card>
        )}

        {/* Notă informativă */}
        <Alert severity="info" sx={{ mt: 3 }}>
          <Typography variant="body2">
            <strong>Notă:</strong> Schimbările la adresa de email trebuie făcute prin setările contului de autentificare.
            Contactul telefonic este opțional, dar recomandat pentru comunicare rapidă.
          </Typography>
        </Alert>
      </Container>

      {/* Dialog pentru schimbarea parolei */}
      <Dialog 
        open={changePasswordOpen} 
        onClose={resetPasswordDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <KeyIcon color="primary" />
          Schimbă parola
        </DialogTitle>
        
        <DialogContent>
          {passwordError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {passwordError}
            </Alert>
          )}
          
          {passwordSuccess && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {passwordSuccess}
            </Alert>
          )}
          
          <Box sx={{ mt: 1 }}>
            {/* Parola curentă */}
            <TextField
              fullWidth
              label="Parola curentă"
              name="currentPassword"
              type={showPasswords.current ? 'text' : 'password'}
              value={passwordData.currentPassword}
              onChange={handlePasswordChange}
              margin="normal"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon color="action" />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => togglePasswordVisibility('current')}
                      edge="end"
                    >
                      {showPasswords.current ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {/* Noua parolă */}
            <TextField
              fullWidth
              label="Noua parolă"
              name="newPassword"
              type={showPasswords.new ? 'text' : 'password'}
              value={passwordData.newPassword}
              onChange={handlePasswordChange}
              margin="normal"
              helperText="Minim 6 caractere"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon color="action" />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => togglePasswordVisibility('new')}
                      edge="end"
                    >
                      {showPasswords.new ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {/* Confirmă parola */}
            <TextField
              fullWidth
              label="Confirmă noua parolă"
              name="confirmPassword"
              type={showPasswords.confirm ? 'text' : 'password'}
              value={passwordData.confirmPassword}
              onChange={handlePasswordChange}
              margin="normal"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon color="action" />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => togglePasswordVisibility('confirm')}
                      edge="end"
                    >
                      {showPasswords.confirm ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button 
            onClick={resetPasswordDialog}
            disabled={passwordLoading}
          >
            Anulează
          </Button>
          <Button
            variant="contained"
            onClick={handleChangePassword}
            disabled={passwordLoading}
            startIcon={passwordLoading ? <CircularProgress size={20} /> : null}
          >
            {passwordLoading ? 'Se procesează...' : 'Schimbă parola'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog pentru detalii modul */}
      <Dialog 
        open={moduleDialogOpen} 
        onClose={() => setModuleDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <SchoolIcon color="primary" />
          {selectedModule?.cod} - {selectedModule?.nume}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mb: 2, display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap', rowGap: 1 }}>
            <Chip 
              label={`${selectedModule?.curricular || 0} Curricular`}
              color="primary"
              variant="outlined"
              size="small"
            />
            <Chip 
              label={`${selectedModule?.extracurricular || 0} Extracurricular`}
              sx={{ borderColor: 'warning.main', color: 'warning.main' }}
              variant="outlined"
              size="small"
            />
            <Chip 
              label={`${selectedModule?.transferabil || 0} Transferabil`}
              color="success"
              variant="outlined"
              size="small"
            />
          </Box>
          
          <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
            Activități care au generat credite:
          </Typography>
          
          {moduleRequests.length === 0 ? (
            <Alert severity="info">Nu există activități pentru acest modul.</Alert>
          ) : (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Activitate</TableCell>
                  <TableCell align="center">Categorie</TableCell>
                  <TableCell align="right">Credite</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {moduleRequests.map((req) => (
                  <TableRow key={req.id}>
                    <TableCell>
                      <Typography variant="body2" noWrap sx={{ maxWidth: 200 }}>
                        {req.nume_activitate}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {new Date(req.data_cerere).toLocaleDateString('ro-RO')}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Chip 
                        label={req.credit_types_v2?.categorie || 'N/A'}
                        size="small"
                        color={
                          req.credit_types_v2?.categorie === 'curricular' ? 'primary' :
                          req.credit_types_v2?.categorie === 'extracurricular' ? 'warning' :
                          'success'
                        }
                      />
                    </TableCell>
                    <TableCell align="right">
                      <Typography fontWeight="bold" color="primary">
                        +{req.credite_acordate}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModuleDialogOpen(false)}>Închide</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}